import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useFocusedAnnotationId = () => {
  const {
    focusedAnnotationIdAtom
  } = useSidePanel();
  const focusedAnnotationId = useAtomValue(focusedAnnotationIdAtom);
  return focusedAnnotationId;
};